import { useEffect, useState } from "react";

export default function SplashScreen({ onDone }) {
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setFading(true), 1800);
    const t2 = setTimeout(() => onDone && onDone(), 2200);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [onDone]);

  return (
    <div
      className={`fixed inset-0 z-50 flex flex-col items-center justify-center transition-opacity duration-500 ${fading ? "opacity-0 pointer-events-none" : "opacity-100"}`}
      style={{ background: "#0D0B14" }}
    >
      {/* Pulse rings */}
      <div className="relative flex items-center justify-center">
        <div className="absolute w-32 h-32 rounded-full animate-ping opacity-10" style={{ background: "radial-gradient(circle, #7C3AED, #EC4CB8)" }} />
        <div className="absolute w-24 h-24 rounded-full animate-ping opacity-20 animation-delay-150" style={{ background: "radial-gradient(circle, #7C3AED, #EC4CB8)", animationDelay: "0.15s" }} />

        {/* Logo mark */}
        <div className="relative w-24 h-24 rounded-2xl flex items-center justify-center overflow-hidden">
          <img src="/logo512.png" alt="EarnMate" className="w-full h-full object-contain" />
        </div>
      </div>

      {/* Wordmark */}
      <div className="mt-6 text-center">
        <p className="text-xs text-slate-500 mt-1 tracking-widest">HIRE · EARN · CONNECT</p>
      </div>
    </div>
  );
}
